// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IrvoAq2QsQpcclFz3ARI {
  position: relative;
  background: linear-gradient(180deg, #a00500 0%, #7c0500 100%);
  box-shadow: 0px 0px 4.5px 0px #000000;
  border-radius: 9px;
  top: -10px;
  min-width: 275px;
  max-width: 318px;
  padding: 2px 3px;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
  gap: 0px;
  flex: 0 0 auto;
  height: 36px;
}
.VSnrcduztLz5KVClaOrA {
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: stretch;
  gap: 0px;
  flex: 1 1 auto;
  width: 100%;
}
.VSnrcduztLz5KVClaOrA span {
  font-family: var(--font-family-primary);
  font-weight: 500;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0.6px;
  text-align: center;
  vertical-align: middle;
  color: #ffe1e1;
}
/*Responsive adjustments - using CSS variables for consistency */
@media (max-width: 1025px) {
  .IrvoAq2QsQpcclFz3ARI {
    --jp-panel-width: 352px;
    margin-top: 4px;
  }
}
.zMAV1FqhYEZuLOHCtEQf {
  background: #1f0507;
  backdrop-filter: blur(4.49524px);
  border-radius: 9px;
  display: flex;
  gap: 8px;
  flex-direction: row;
  /* Ensures elements are in a row */
  justify-content: center;
  flex: 0 0 auto;
  height: 32px;
  width: 125px;
  margin: 0px 2px;
  padding: 0 10px;
}
.zMAV1FqhYEZuLOHCtEQf img {
  position: relative;
  width: auto;
  height: 32px;
  min-width: 26px;
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/LinkedJackpots/LinkedJackpots.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,QAAQ;EACR,cAAc;EACd,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA,gEAAgE;AAChE;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".linkedJackpots {\n  position: relative;\n  background: linear-gradient(180deg, #a00500 0%, #7c0500 100%);\n  box-shadow: 0px 0px 4.5px 0px #000000;\n  border-radius: 9px;\n  top: -10px;\n  min-width: 275px;\n  max-width: 318px;\n  padding: 2px 3px;\n  display: flex;\n  flex-flow: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0px;\n  flex: 0 0 auto;\n  height: 36px;\n}\n.textWrapper {\n  display: flex;\n  flex-flow: row;\n  justify-content: center;\n  align-items: stretch;\n  gap: 0px;\n  flex: 1 1 auto;\n  width: 100%;\n}\n.textWrapper span {\n  font-family: var(--font-family-primary);\n  font-weight: 500;\n  font-size: 11px;\n  line-height: 100%;\n  letter-spacing: 0.6px;\n  text-align: center;\n  vertical-align: middle;\n  color: #ffe1e1;\n}\n/*Responsive adjustments - using CSS variables for consistency */\n@media (max-width: 1025px) {\n  .linkedJackpots {\n    --jp-panel-width: 352px;\n    margin-top: 4px;\n  }\n}\n.imagesContainer {\n  background: #1f0507;\n  backdrop-filter: blur(4.49524px);\n  border-radius: 9px;\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  /* Ensures elements are in a row */\n  justify-content: center;\n  flex: 0 0 auto;\n  height: 32px;\n  width: 125px;\n  margin: 0px 2px;\n  padding: 0 10px;\n}\n.imagesContainer img {\n  position: relative;\n  width: auto;\n  height: 32px;\n  min-width: 26px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkedJackpots": `IrvoAq2QsQpcclFz3ARI`,
	"textWrapper": `VSnrcduztLz5KVClaOrA`,
	"imagesContainer": `zMAV1FqhYEZuLOHCtEQf`
};
export default ___CSS_LOADER_EXPORT___;
